import { EUserType } from 'services/BackendApi';

export const CAN_UPLOAD = 'CAN_UPLOAD';
export const CAN_READ_PRIVATE = 'CAN_READ_PRIVATE';
export const CAN_READ_VOUCHER_V2 = 'CAN_READ_VOUCHER_V2';

const ROLES_AND_PERMISSIONS: Record<EUserType, string[]> = {
  [EUserType.ADMIN]: [
    CAN_UPLOAD,
    CAN_READ_PRIVATE,
    CAN_READ_VOUCHER_V2
  ],
  [EUserType.FINANCE]: [
    CAN_UPLOAD,
    CAN_READ_PRIVATE,
    CAN_READ_VOUCHER_V2
  ],
  [EUserType.RL]: [
  ],
  [EUserType.SR]: [
    CAN_UPLOAD,
    CAN_READ_PRIVATE,
    CAN_READ_VOUCHER_V2
  ],
  [EUserType.SALES]: [
  ],
  [EUserType.TA]: [
    CAN_READ_VOUCHER_V2
  ],
  [EUserType.MARKETING]: [
  ],
};

export const hasPermissions = (userType: EUserType, permissions: string): boolean =>
  (ROLES_AND_PERMISSIONS[userType] || []).includes(permissions);
